import React from 'react';
import Gauge from './Gauge';

// Presentational: shows the room temperature from /status. Null until the thermometer has reported.
const TemperatureGauge = ({ value }) => {
  const actual = value != null ? Number(Number(value).toFixed(1)) : null;
  return (
    <div className="temperature-gauge">
      <Gauge min={5} max={40} actual={actual} />
    </div>
  );
};

export default TemperatureGauge;
